var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0358 8.54834C38.0615 8.91001 38.0615 9.27167 38.0615 9.63667C38.0615 20.7583 29.3559 33.585 13.4372 33.585V33.5783C8.73479 33.585 4.13006 32.275 0.171387 29.805C0.855157 29.885 1.54235 29.925 2.23127 29.9267C6.12824 29.93 9.91383 28.6583 12.9797 26.3167C9.27633 26.2483 6.02885 23.9 4.89437 20.4717C6.19165 20.715 7.52834 20.665 8.80163 20.3267C4.76413 19.5333 1.85939 16.0833 1.85939 12.0767C1.85939 12.04 1.85939 12.005 1.85939 11.97C3.06241 12.6217 4.40939 12.9833 5.78721 13.0233C1.98449 10.5517 0.812314 5.63167 3.10868 1.785C7.50264 7.04334 13.9856 10.24 20.945 10.5783C20.2475 7.655 21.2003 4.59167 23.4487 2.53667C26.9344 -0.649998 32.4165 -0.486664 35.6932 2.90167C37.6314 2.53 39.489 1.83834 41.189 0.858336C40.543 2.80667 39.1908 4.46167 37.3846 5.51334C39.1 5.31667 40.776 4.87 42.3543 4.18834C41.1925 5.88167 39.7289 7.35667 38.0358 8.54834Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.5,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogoBlack);
export default __webpack_public_path__ + "static/media/Twitter-logo-black.bfbc66c1a2933eff41fd4b2f78d6ceed.svg";
export { ForwardRef as ReactComponent };